/**
 * Marketing site layout with navigation and footer.
 * Provides consistent structure for all public marketing pages.
 */

import { Link } from 'react-router-dom';
import './marketing.css';

interface MarketingLayoutProps {
    children: React.ReactNode;
}

export function MarketingLayout({ children }: MarketingLayoutProps): JSX.Element {
    return (
        <div className="marketing-layout">
            {/* Navigation */}
            <nav className="marketing-nav">
                <div className="marketing-nav-inner">
                    <Link to="/" className="marketing-nav-logo">
                        <img src="/irpilot-logo.svg" alt="IRPilot" className="marketing-logo-full" />
                    </Link>

                    <div className="marketing-nav-links">
                        <Link to="/platform" className="marketing-nav-link">
                            Platform
                        </Link>
                        <Link to="/pricing" className="marketing-nav-link">
                            Pricing
                        </Link>
                        <Link to="/login" className="marketing-nav-cta">
                            Sign In
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="marketing-main">
                {children}
            </main>

            {/* Footer */}
            <footer className="marketing-footer">
                <div className="marketing-footer-inner">
                    <div className="marketing-footer-links">
                        <Link to="/platform" className="marketing-footer-link">
                            Platform
                        </Link>
                        <Link to="/pricing" className="marketing-footer-link">
                            Pricing
                        </Link>
                        <Link to="/privacy" className="marketing-footer-link">
                            Privacy
                        </Link>
                        <Link to="/sms-terms" className="marketing-footer-link">
                            SMS Terms
                        </Link>
                        <Link to="/terms" className="marketing-footer-link">
                            Terms
                        </Link>
                    </div>
                    <p className="marketing-footer-text">
                        Protected by Microsoft Entra ID
                    </p>
                </div>
            </footer>
        </div>
    );
}
